export default __webpack_public_path__ + "static/media/qrbb.817c90aa.png";